<template>
  <div>
    <Fontnavbar title="订单列表" />
    <div>
      <van-search
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <van-tabs
      v-model="active"
      :swipe-threshold="5"
      sticky
      animated
      @change="exchange_active"
    >
      <van-tab
        :title="vo"
        v-for="(vo,voi) in active_name"
        :key="voi"
      >
        <div class="list-item">
          <!-- order -->
          <van-panel
            v-for="(item,i) in order"
            :key="i"
            class="order_list--panel"
            :title="'订单号：'+item.order_no"
            :status="item.order_status_name"
            @click="goPage('/order/detail?order_no='+item.order_no)"
          >
            <div class="QQQ">
              <div class="TTT">
                收货人:{{item.user_name}}
              </div>
              <div class="AAA">手机号:{{item.user_phone}}</div>
            </div>
            <div class="QQQ">
              <div class="TTT">
                {{item.logistic_name}} : {{item.logistic_no ? item.logistic_no : '--'}}
              </div>
            </div>
            <div>

              <div>
                <div>
                  <van-card
                    class="order_list--van-card"
                    :num="item.goods[0].goods_num"
                    :price="item.goods[0].goods_price"
                    desc
                    :title="item.goods[0].goods_name"
                    :thumb="imgDomain+''+item.goods[0].goods_thumb_path"
                  >
                    <div slot="footer">
                      <van-button
                        v-if="item.order_status == 40 && item.has_after_sales == 1"
                        round
                        type="info"
                        plain
                        color="red"
                        size="small"
                        @click.stop="goPage(`/order/logistics?logistic_code=${item.logistic_code}&logistic_no=${item.logistic_no}&logistic_name=${item.logistic_name}`)"
                      >查看物流</van-button>
                      <van-button
                        v-if="( item.order_status == 40 || item.order_status == 50 || item.order_status == 60 ) && item.has_after_sales == 1"
                        round
                        type="info"
                        plain
                        color="green"
                        size="small"
                        @click.stop="goAfter()"
                      >售后详情</van-button>
                      <van-button
                        v-if="( item.order_status == 40 || item.order_status == 50 || item.order_status == 60 ) && item.has_after_sales == 0 && item.able_after_sales == 1"
                        round
                        type="info"
                        plain
                        color="red"
                        size="small"
                        @click.stop="goPages(item.order_no)"
                      >申请售后</van-button>
                      <van-button
                          v-if="item.is_group_buy == 1 && item.order_status != 11"
                          round
                          type="info"
                          plain
                          color="orange"
                          size="small"
                          @click.stop="goPage('/goods/groupBuy/orderDetail?sn=' + item.part_sn)"
                      >拼团订单详情</van-button>
                    </div>
                  </van-card>
                </div>
              </div>

              <div class="order_list--total">合计: {{item.total_price}}（含运费{{item.freight}}）</div>

              <div
                slot="footer"
                class="order_list--footer_btn"
                v-if="(item.pay_id == 3||item.pay_id == 4) && (item.order_status == 10 || item.order_status == 20)"
              >
                <van-count-down
                  class="count-down"
                  :time="downTime(item.create_stamp)"
                >
                  <template #default="timeData">
                    <span class="block">{{ timeData.hours }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{ timeData.minutes }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{ timeData.seconds }}</span>
                    <span style="margin-left: 10px;">后订单自动取消</span>
                  </template>
                </van-count-down>
                <van-button
                  size="small"
                  type="danger"
                  v-if="(item.pay_id == 3 ||item.pay_id == 4) && (item.order_status == 10 || item.order_status == 20)"
                  @click.stop="goPay(item.id)"
                >去支付</van-button>
              </div>
            </div>

          </van-panel>

          <div
            class="empty"
            v-if="order.length==0"
          >暂时没有相关数据！</div>
          <!-- 页面加载 -->
          <!-- <div v-if="loading" style="text-align: center;">
            <van-loading size="24px">加载中...</van-loading>
          </div> -->
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { orderList, wxPay } from '../../api.js'
import { post } from '../../request.js'
import Fontnavbar from '../../components/Navbar.vue'

import {
    Loading,
    Toast,
    Panel,
    NavBar,
    Divider,
    Icon,
    Button,
    Tag,
    Tab,
    Tabs,
    Search,
    Card,
    CountDown,
    PullRefresh, Dialog,
} from 'vant'

export default {
  components: {
    [Loading.name]: Loading,
    [Search.name]: Search,
    [PullRefresh.name]: PullRefresh,
    [Toast.name]: Toast,
    [Panel.name]: Panel,
    [NavBar.name]: NavBar,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Card.name]: Card,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CountDown.name]: CountDown,
    Fontnavbar,
  },

  data() {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      active: 0,
      active_name: ['全部', '待付款', '待发货', '待收货', '已完成'],
      order: [],
      order_status: -1, //订单状态
      loading: true,
      page: 1, //当前页
      backserve: '',
      value: '',
    }
  },

  created() {
    if (this.$store.state.user.loginStatus !== 1) {
      this.$router.push({ path: '/user/login' })
      return false
    }
    const that = this

    // window.console.log(that.$route.query.active);
    if (that.$route.query.order_status) {
      that.order_status = parseInt(that.$route.query.order_status)
      that.active = parseInt(that.$route.query.active)
    }

    that.get_order_list(that.order_status)
  },
  methods: {
    //搜索
    onSearch() {
      post(orderList, { keyword: this.value }).then((res) => {
        if (res.code == 200) {
          this.order = res.data
        } else {
          Toast('网络错误')
        }
      })
    },
    goPage(path) {
      this.$router.push({ path: path })
    },
    goAfter() {
      this.$router.push({ path: '/service/servicelist' })
    },
    goPay(order_id) {
        var that = this
        if (that){
            let ua = window.navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                var loading = Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                })
                post(wxPay, {
                    order_id: order_id,
                    pay_id: 3,
                }).then((res) => {
                    loading.clear()
                    if (res.code == 200) {
                        if (res.pay_info.mweb_url) {
                            window.location.href = res.pay_info.mweb_url
                        }
                        that.wx_response = res.pay_info.response
                        that.weixinPay(res.pay_info.response)
                    } else {
                        Toast(res.msg)
                    }
                })
                return;
            }
            Dialog.confirm({
                title: '提示',
                message: '请选择支付方式！',
                confirmButtonText: '微信',
                confirmButtonColor:'green',
                cancelButtonText: '支付宝',
                cancelButtonColor: 'blue',
            })
                .then(() => {
                    // console.log('微信')

                    var loading = Toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    })
                    post(wxPay, {
                        order_id: order_id,
                        pay_id: 3,
                    }).then((res) => {
                        loading.clear()
                        if (res.code == 200) {
                            if (res.pay_type == 'alipay') {
                                //   支付宝支付
                                const div = document.createElement('div')
                                /* 此处form就是后台返回接收到的数据 */
                                div.innerHTML = res.pay_info
                                document.body.appendChild(div)
                                document.forms[0].submit()
                            } else {
                                // console.log(res)
                                // 去支付
                                if (res.pay_info.mweb_url) {
                                    window.location.href = res.pay_info.mweb_url
                                }
                                that.wx_response = res.pay_info.response
                                that.weixinPay(res.pay_info.response)
                            }
                        } else {
                            Toast(res.msg)
                        }
                    })


                })
                .catch(() => {
                    // console.log('支付宝')
                    var loading = Toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    })
                    post(wxPay, {
                        order_id: order_id,
                        pay_id: 4,
                    }).then((res) => {
                        loading.clear()
                        if (res.code == 200) {
                            if (res.pay_type == 'alipay') {
                                //   支付宝支付
                                const div = document.createElement('div')
                                /* 此处form就是后台返回接收到的数据 */
                                div.innerHTML = res.pay_info
                                document.body.appendChild(div)
                                document.forms[0].submit()
                            } else {
                                // console.log(res)
                                // 去支付
                                if (res.pay_info.mweb_url) {
                                    window.location.href = res.pay_info.mweb_url
                                }
                                that.wx_response = res.pay_info.response
                                that.weixinPay(res.pay_info.response)
                            }
                        } else {
                            Toast(res.msg)
                        }
                    })
                });
        }

    },
    goPages(order_no) {
      // console.log(item, item_goods)
      // this.$router.push({
      //   path: '/service/backservice',
      //   query: {
      //     goodsDetail: JSON.stringify(item_goods)
      //   }
      // })
      this.$router.push({
        path: '/service/apply',
        query: {
          order_no: order_no,
        },
      })
    },
    //切换tab
    exchange_active(index) {
      this.page = 1

      const that = this
      that.order = []

      var order_status = -1
      switch (index) {
        case 0:
          order_status = -1
          break
        case 1:
          order_status = 20
          break
        case 2:
          order_status = 30
          break
        case 3:
          order_status = 40
          break
        case 4:
          order_status = 60
          break
      }
      that.get_order_list(order_status)
    },
    //获取订单列表
    get_order_list(order_status) {
      const that = this
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      post(orderList, { order_status: order_status, page: that.page }).then(
        (res) => {
          loading.clear()
          if (res.code == 200) {
            if (that.page == 1) {
              that.order = res.data
            } else {
              that.order = that.order.concat(res.data)
            }
            if (res.data.length == 0) {
              that.loading = false
            }
            // window.console.log(that.order.length);
          } else if (res.code == 201) {
            this.$router.push({ path: '/user/login' })
            return false
          } else {
            Toast('网络错误')
          }
        }
      )
    },
    //解决微信内置对象报错
    weixinPay(data) {
      var that = this
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            that.onBridgeReady(data),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady(data))
          document.attachEvent(
            'onWeixinJSBridgeReady',
            that.onBridgeReady(data)
          )
        }
      } else {
        that.onBridgeReady()
      }
    },

    //微信内置浏览器类，weChatParameter对象中的参数是3.步骤代码中从后端获取的数据
    onBridgeReady() {
      var that = this
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        that.wx_response,
        function (res) {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            Toast({
              message: '支付成功',
              position: 'middle',
              duration: 3000,
            })
            that.get_order_list(that.order_status)
            //window.location.href = that.BASE_URL + 'index.html#/depositResult'
          } else {
            Toast({
              message: '支付失败',
              position: 'middle',
              duration: 3000,
            })
          }
        }
      )
    },
  },
  computed: {
    now: function () {
      return Date.now()
    },
    downTime() {
      return function (timestamp) {
        timestamp = (timestamp + 60 * 15) * 1000
        if (timestamp > this.now) {
          return timestamp - this.now
        }
        return 0
      }
    },
  },
}
</script>

<style lang="less" scoped>
.order_list--panel {
  margin-bottom: 10px;
}
.order_list--panel span {
  font-size: 12px;
}
.order_list--total {
  text-align: right;
  padding: 10px;
  border: 1px solid #fafafa;
}
.order_list--footer_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px 0 10px 0;
}

.empty {
  margin-top: 40%;
  text-align: center;
}
.QQQ {
  margin-top: 3%;
  margin-bottom: 3%;
  display: flex;
  margin-left: 5%;
  font-size: 12px;
  white-space: nowrap;
}

.AAA {
  padding-left: 5%;
}
.ZZZ {
  padding-left: 25%;
}
.order_list--panel {
  .van-cell__title {
    min-width: 70%;
  }
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}
.van-count-down {
  margin-left: 20px;
}
.order_list--footer_btn .van-button {
  margin-right: 20px;
}
</style>
